import { CodeLanguage } from '../types';

export const getUnifiedCodeLanguageId = (
  language: CodeLanguage | string,
): CodeLanguage | string => {
  switch (language) {
    case 'js':
    case 'jsx':
    case 'javascript':
      return 'js';
    case 'ts':
    case 'tsx':
    case 'typescript':
      return 'ts';
    case 'objective-c':
    case 'objc':
      return 'objectivec';
    case 'node.js':
    case 'nodejs':
    case 'node':
      return 'node';
    case 'next.js':
    case 'nextjs':
    case 'next':
      return 'nextjs';
    default:
      return language;
  }
};
